var _path, _path2, _path3;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgSwapIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1592 10.1867C19.1592 15.4814 15.1084 19.7292 10.1648 19.7292C5.22118 19.7292 1.1704 15.4814 1.1704 10.1867C1.1704 4.8919 5.22118 0.644093 10.1648 0.644093C15.1084 0.644093 19.1592 4.8919 19.1592 10.1867Z",
    fill: "white",
    stroke: "#B3B3B3",
    strokeWidth: 0.911111
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2721 7.17602C11.45 6.99812 11.45 6.70968 11.2721 6.53177L8.37298 3.63263C8.19507 3.45473 7.90663 3.45473 7.72872 3.63263C7.55082 3.81054 7.55082 4.09898 7.72872 4.27689L10.3057 6.8539L7.72872 9.43091C7.55082 9.60881 7.55082 9.89726 7.72872 10.0752C7.90663 10.2531 8.19507 10.2531 8.37298 10.0752L11.2721 7.17602ZM5.44141 7.30945H10.95V6.39834H5.44141V7.30945Z",
    fill: "#B3B3B3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.06382 13.1973C8.88592 13.3752 8.88592 13.6636 9.06382 13.8415L11.963 16.7407C12.1409 16.9186 12.4293 16.9186 12.6072 16.7407C12.7851 16.5628 12.7851 16.2743 12.6072 16.0964L10.0302 13.5194L12.6072 10.9424C12.7851 10.7645 12.7851 10.476 12.6072 10.2981C12.4293 10.1202 12.1409 10.1202 11.963 10.2981L9.06382 13.1973ZM14.8945 13.0639L9.38595 13.0639L9.38595 13.975L14.8945 13.975L14.8945 13.0639Z",
    fill: "#B3B3B3"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSwapIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/swap-icon.aa4ce73b.svg";
export { ForwardRef as ReactComponent };